module.exports = __webpack_public_path__ + "img/jazzy-thumbnail-fallback_transparent.eb3d0ef.png";